import React from "react";

import AppliedProjectList from "./AppliedProjectList";
import LoadingSpinner from "../../../../common/LoadingSpinner";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";

import { useGetUserAppliedProjects } from "../../../../utils/useProject";

const AppliedProjectListContaner: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);

  const { projects, isLoading } = useGetUserAppliedProjects({
    auth_token,
    enabled: auth_token ? true: false,
  });

  if (isLoading) {
    return <LoadingSpinner space={1} />;
  } else {
    return <AppliedProjectList projects={projects} />;
  }
};

export default AppliedProjectListContaner;
